import React from 'react';
import { Typography } from '@mui/material';

type PropTypes = {
  isActiveTab: boolean;
  text: string;
};
export const TabLabel = ({ isActiveTab, text }: PropTypes) => {
  return (
    <Typography
      variant={isActiveTab ? 'h5led' : 'h5'}
      letterSpacing={5}
      color={!isActiveTab ? 'secondary.light' : null}
      sx={{
        filter: isActiveTab
          ? 'drop-shadow(0 0 15px #db3eb1) drop-shadow(0 0 50px #db3eb1) contrast(2)'
          : null,
      }}
    >
      {text}
    </Typography>
  );
};
